import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { films } from '@/mocks/films';

export default function SiteIntro() {
  const subCount = categories.reduce((total, category) => total + category.children.length, 0);

  return (
    <div className="overflow-hidden rounded-lg border border-background-300/70 bg-background-100">
      <div className="grid gap-0 md:grid-cols-2">
        <div className="relative h-[240px] w-full md:h-full md:min-h-[360px]">
          <img
            src="https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20quiet%20film%20archive%20room%20with%20wooden%20shelves%20of%20film%20canisters%20and%20a%20single%20warm%20desk%20lamp%2C%20dust%20in%20the%20air%2C%20deep%20charcoal%20and%20amber%20tones%2C%20fine%20film%20grain%2C%20moody%20low%20key%20lighting%2C%20no%20text&width=900&height=700&seq=at-intro-archive&orientation=landscape"
            alt="影视资料库场景"
            title="成人影视 · 影视资料库"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-50/20 to-transparent md:bg-gradient-to-r" />
        </div>
        <div className="p-6 md:p-10">
          <p className="eyebrow mb-3">关于本站</p>
          <h2 className="text-xl font-semibold leading-snug text-foreground-950 md:text-[26px]">
            把散落的信息整理成
            <br className="hidden sm:block" />
            一份可检索的资料库
          </h2>
          <p className="mt-4 text-[13px] leading-7 text-foreground-600">
            成人影视专注于作品条目与行业资讯的整理。我们不以即时播放为目标，而是把导演、主演、年份、片长、类型与简介这些基础信息做完整，让查找和比较变得简单。
          </p>
          <p className="mt-3 text-[13px] leading-7 text-foreground-600">
            分类按题材与地区双线组织，详情页提供简介、标签与同类推荐；记不住片名时，也可以直接用关键词搜索。
          </p>

          <div className="mt-7 grid grid-cols-3 gap-3 border-t border-background-300/70 pt-6">
            {[
              { value: films.length, label: '收录条目' },
              { value: categories.length, label: '主要分类' },
              { value: subCount, label: '子分类' },
            ].map((stat) => (
              <div key={stat.label}>
                <p className="font-heading text-2xl font-semibold text-primary-500">{stat.value}</p>
                <p className="mt-1 text-[11px] tracking-wide text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-[12px] text-foreground-700 transition-colors hover:border-primary-500/60 hover:text-primary-400"
          >
            了解内容范围与声明
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </div>
  );
}